import React from "react";
import { Link } from "react-router-dom";
import { Mail, Lock } from "lucide-react";
import { BRAND_LOGO_LOCKUP } from "../lib/data";
import { useShellTheme } from "./layout/ShellTheme";

const Footer = () => {
  const dark = useShellTheme() === "dark";
  const link = dark
    ? "text-[15px] text-ivory/80 hover:text-goldhover transition"
    : "text-[15px] text-cream/90 hover:text-gold transition";

  const links = [
    { to: "/shop", label: "Shop" },
    { to: "/reviews", label: "Reviews" },
    { to: "/community-reward", label: "Reward" },
    { to: "/learn", label: "Learn" },
    { to: "/contact", label: "Contact" },
    { to: "/privacy-policy", label: "Privacy" },
    { to: "/terms", label: "Terms" },
  ];

  return (
    <footer
      className={
        dark
          ? "bg-void text-ivory border-t border-white/12 pt-12 pb-[calc(7.5rem+env(safe-area-inset-bottom,0px))] lg:pb-10"
          : "bg-forest text-cream pt-14 pb-[calc(7.5rem+env(safe-area-inset-bottom,0px))] lg:pb-10"
      }
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full bg-ivory p-2 ring-1 ring-white/20"
            >
              <img src={BRAND_LOGO_LOCKUP} alt="Moss Matrix" className="h-14 w-14 object-contain" />
            </Link>
            <p className={`mt-5 text-[15px] max-w-sm leading-relaxed ${dark ? "text-sage" : "text-cream/75"}`}>
              Freshly prepared in small batches. For real routines, not mass-produced shelves.
            </p>
            <a
              className={`mt-5 inline-flex items-center gap-2 text-sm transition ${
                dark ? "text-ivory/80 hover:text-goldhover" : "text-cream/80 hover:text-gold"
              }`}
              href="mailto:info@mossmatrix.com"
              aria-label="Email MossMatrix"
            >
              <Mail className="w-4 h-4" strokeWidth={1.5} />
              info@mossmatrix.com
            </a>
          </div>

          <nav className="md:col-span-7" aria-label="Footer">
            <ul className="flex flex-wrap gap-x-6 gap-y-3 text-sm">
              {links.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className={link}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div
          className={`mt-10 pt-5 flex flex-wrap items-center justify-between gap-4 text-xs ${
            dark ? "border-t border-white/12 text-sage/80" : "border-t border-cream/10 text-cream/55"
          }`}
        >
          <div>© {new Date().getFullYear()} MossMatrix. UK delivery only.</div>
          <Link
            to="/admin"
            className={`inline-flex items-center justify-center w-8 h-8 rounded-full transition ${
              dark
                ? "border border-white/15 text-ivory/35 hover:text-ivory hover:border-ivory/40"
                : "border border-cream/15 text-cream/40 hover:text-cream hover:border-cream/40"
            }`}
            aria-label="Admin login"
            title="Admin login"
          >
            <Lock className="w-3.5 h-3.5" strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
